enum AccountSubCategory {
  BSU_ACCOUNT = 'BSU_ACCOUNT',
  CASHPOOL_ACCOUNT = 'CASHPOOL_ACCOUNT',
  CLIENT_ACCOUNT = 'CLIENT_ACCOUNT',
  CURRENT_ACCOUNT = 'CURRENT_ACCOUNT',
  CURRENCY_ACCOUNT = 'CURRENCY_ACCOUNT',
  CURRENT_ACCOUNT_NOTPAYABLE = 'CURRENT_ACCOUNT_NOTPAYABLE',
  ESCROW_ACCOUNT = 'ESCROW_ACCOUNT',
  FIXED_RATE_ACCOUNT = 'FIXED_RATE_ACCOUNT',
  LORO_NOSTRO_ACCOUNT = 'LORO_NOSTRO_ACCOUNT',
  MORTGAGE_LOAN = 'MORTGAGE_LOAN',
  OTHER_LOANS = 'OTHER_LOANS',
  SAVING_ACCOUNT = 'SAVING_ACCOUNT',
  SAVING_ACCOUNT_NOTPAYABLE = 'SAVING_ACCOUNT_NOTPAYABLE',
  STOCK_CURRENT_ACCOUNT = 'STOCK_CURRENT_ACCOUNT',
  STOCK_CURRENT_ACCOUNT_WITH_VFA = 'STOCK_CURRENT_ACCOUNT_WITH_VFA',
  STOCK_SAVING_ACCOUNT = 'STOCK_SAVING_ACCOUNT',
  STOCK_SAVING_ACCOUNT_WITH_VFA = 'STOCK_SAVING_ACCOUNT_WITH_VFA',
  TAX_ACCOUNT = 'TAX_ACCOUNT',
}

export default AccountSubCategory;
